var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarMinimalistic1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.5V9C16.5 8.37075 16.5 7.81147 16.4903 7.3125H1.50968C1.5 7.81147 1.5 8.37075 1.5 9V10.5C1.5 13.3284 1.5 14.7427 2.37868 15.6213C3.25736 16.5 4.67157 16.5 7.5 16.5H10.5C13.3284 16.5 14.7427 16.5 15.6213 15.6213C16.5 14.7427 16.5 13.3284 16.5 10.5Z",
    fill: "#40356F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81165 1.875C5.81165 1.56434 5.55981 1.3125 5.24915 1.3125C4.93849 1.3125 4.68665 1.56434 4.68665 1.875V3.05944C3.60715 3.14588 2.89848 3.35803 2.37783 3.87868C1.85718 4.39933 1.64503 5.108 1.55859 6.1875H16.4397C16.3533 5.108 16.1411 4.39933 15.6204 3.87868C15.0998 3.35803 14.3911 3.14588 13.3116 3.05944V1.875C13.3116 1.56434 13.0598 1.3125 12.7491 1.3125C12.4385 1.3125 12.1866 1.56434 12.1866 1.875V3.00967C11.6877 3 11.1284 3 10.4991 3H7.49915C6.86988 3 6.3106 3 5.81165 3.00967V1.875Z",
    fill: "#40356F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMinimalistic1);
export default __webpack_public_path__ + "static/media/calendar-minimalistic 1.0ac7226a0cc450ba6da5ae091d55cc02.svg";
export { ForwardRef as ReactComponent };